import React from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from 'ui/components/styled';

export const LinkButton = ({ children, onClick, to, disabled, ...rest }) => {
  const history = useHistory();

  const handleClick = (event) => {
    if (disabled) {
      return;
    }
    if (onClick) {
      onClick(event);
    }
    history.push(to);
  };

  return (
    <Button {...rest} onClick={handleClick} disabled={disabled}>
      {children}
    </Button>
  );
};
